import { render } from "./User.vue?vue&type=template&id=6130f788&scoped=true"
import script from "./User.vue?vue&type=script&lang=js"
export * from "./User.vue?vue&type=script&lang=js"

import "./User.vue?vue&type=style&index=0&id=6130f788&lang=scss&scoped=true"

import exportComponent from "/home/controlcenter/sourcecode/dubiverse/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6130f788"]])

export default __exports__